//ハンバーガーメニュー開閉（Vanilla JS）
document.querySelectorAll('.btn-burger').forEach(function(btn) {
  btn.addEventListener('click', function() {
    this.closest('.drawer').classList.toggle('is-open');
  });
});

(function($) {

//logoの表示
$(window).on('load',function(){
	$("#splash").delay(1500).fadeOut('slow');//ローディング画面を1.5秒（1500ms）待機してからフェードアウト
	$("#splash_logo").delay(1200).fadeOut('slow');//ロゴを1.2秒（1200ms）待機してからフェードアウト
  });

//スクロールをするとハンバーガーメニューに変化するための設定を関数でまとめる
function FixedAnime() {
	//ヘッダーの高さを取得
	var headerH = $('#header').outerHeight(true);
	var scroll = $(window).scrollTop();
	if (scroll >= headerH){//ヘッダーの高さ以上までスクロールしたら
		$('.openbtn1').addClass('fadeDown');//.openbtnにfadeDownというクラス名を付与して
		$('#header').addClass('dnone');//#headerにdnoneというクラス名を付与
	  }else{//それ以外は
		$('.openbtn1').removeClass('fadeDown');//fadeDownというクラス名を除き
		$('#header').removeClass('dnone');//dnoneというクラス名を除く
	  }
  }

  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
	FixedAnime();//スクロールをするとハンバーガーメニューに変化するための関数を呼ぶ
  });

  // ページが読み込まれたらすぐに動かしたい場合の記述
  $(window).on('load', function () {
	FixedAnime();//スクロールをするとハンバーガーメニューに変化するための関数を呼ぶ
  });


  //ボタンをクリックした際のアニメーションの設定
  $(".openbtn1").click(function () {//ボタンがクリックされたら
	$(this).toggleClass('active');//ボタン自身に activeクラスを付与し
	  $("#header").toggleClass('panelactive');//ヘッダーにpanelactiveクラスを付与
  });
  $("#g-navi li a").click(function () {//ナビゲーションのリンクがクリックされたら
	  $(".openbtn1").removeClass('active');//ボタンの activeクラスを除去し
	  $("#header").removeClass('panelactive');//ヘッダーのpanelactiveクラスも除去
  });


  //リンク先のidまでスムーススクロール
  //※ページ内リンクを行わない場合は不必要なので削除してください
	  $('#g-navi li a').click(function () {
	var elmHash = $(this).attr('href');
	var pos = $(elmHash).offset().top-0;
	$('body,html').animate({scrollTop: pos}, 1000);
	return false;
  });

var beforePos = 0;//スクロールの値の比較用の設定

//スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
function ScrollAnime() {
    var elemTop = $('#message').offset().top;//#area-2の位置まできたら
  var scroll = $(window).scrollTop();
    //ヘッダーの出し入れをする
    if(scroll == beforePos) {
    //IE11対策で処理を入れない
    }else if(elemTop > scroll || 0 > scroll - beforePos){
    //ヘッダーが上から出現する
    $('#float_sns').removeClass('UpMove'); //#headerにUpMoveというクラス名を除き
    $('#float_sns').addClass('DownMove');//#headerにDownMoveのクラス名を追加
    }else {
    //ヘッダーが上に消える
        $('#float_sns').removeClass('DownMove');//#headerにDownMoveというクラス名を除き
    $('#float_sns').addClass('UpMove');//#headerにUpMoveのクラス名を追加
    }

    beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
}

$(function () {
  $(".checkbox").on("change", function () {
    if ($(this).is(":checked")) {
      //チェックが入ったら、送信ボタンを押せる
      $("#form_submit_button").prop("disabled", false);
    } else {
      //チェックが入っていなかったら、送信ボタンを押せない
      $("#form_submit_button").prop("disabled", true);
    }
  });
});

})(jQuery);
